import React from 'react';
import { Menu, MenuProps, useSidebarState } from 'react-admin';
import { Home, PeopleAlt, Receipt, School } from '@mui/icons-material';

import { Paths } from '../../shared/constants/appRoutes';
import { Typography, useTheme } from '@mui/material';
import { useStore } from 'ra-core';

type COCMenuProps = MenuProps;

const MenuTitle = (props: { title: string }) => {
  const sx = {
    root: {
      fontSize: '15px',
      fontWeight: 'bold',
      pl: 1,
      py: 1,
      mt: '10px',
      color: 'grey.200',
    },
  };

  const [sidebarOpen] = useSidebarState();

  if (!sidebarOpen) return null;
  return <Typography sx={sx.root}>{props.title.toUpperCase()}</Typography>;
};

const COCMenu = (props: COCMenuProps) => {
  const [sidebarOpen] = useSidebarState();
  const theme = useTheme();
  const [isEmployee] = useStore('isEmployee', true);

  const sx = {
    root: {
      '& .MuiMenuItem-root, & .RaMenuItemLink-active, & .MuiListItemIcon-root': {
        color: theme.palette.grey['300'],
        fontSize: '14px',
        padding: theme.spacing(0.5, 0, 0.5, 0.5),
        mx: 1.5,
        borderRadius: '12px',
        '&:hover': {
          backgroundColor: 'rgba(0, 150, 212, 0.15)',
          color: theme.palette.common.white,
          '& .MuiListItemIcon-root': {
            color: theme.palette.common.white,
          },
        },
      },
      '&&&&&&&&&&& .MuiMenuItem-root': {
        my: 0.5,
      },
      '&& .RaMenuItemLink-icon': {
        ml: 0.5,
        mr: -1,
      },
      '& .RaMenuItemLink-active': {
        // borderLeft: '3px solid #fff',
        color: `${theme.palette.common.white} !important`,
        backgroundColor: 'rgba(0, 150, 212, 0.5)',
        '& .MuiListItemIcon-root': {
          color: 'common.white',

          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
          color: theme.palette.common.white,
        },
      },
      '& .MuiListItemIcon-root': {
        marginRight: sidebarOpen ? 0 : 8,
      },
      '& .MuiSvgIcon-root': {
        width: '0.9em',
        height: '0.9em',
      },
    },
  };

  const AdminLayout = (
    <>
      {/*<MenuTitle title="Configuration" />*/}
      <Menu.Item
        disableRipple
        to={Paths.ClubProfile}
        primaryText="Club Profile"
        leftIcon={<Home />}
      />
      <Menu.Item
        disableRipple
        to={Paths.Billing}
        primaryText="Billing"
        leftIcon={<Receipt />}
      />
      <Menu.Item
        disableRipple
        to={Paths.Clubs}
        primaryText="Team Management"
        leftIcon={<PeopleAlt />}
      />
      <Menu.Item
        disableRipple
        to={Paths.Academy}
        primaryText="Swish Academy"
        leftIcon={<School />}
      />
    </>
  );

  const EmployeeLayout = (
    <>
      {/*<MenuTitle title="Configuration" />*/}
      <Menu.Item
        disableRipple
        to={Paths.ClubProfile}
        primaryText="Club Profile"
        leftIcon={<Home />}
      />
      <Menu.Item
        disableRipple
        to={Paths.Academy}
        primaryText="Swish Academy"
        leftIcon={<School />}
      />
    </>
  );

  return (
    <Menu sx={sx.root} {...props}>
      {isEmployee ? EmployeeLayout : AdminLayout}
    </Menu>
  );
};

export default COCMenu;
